import { useRef, useEffect } from 'react';

const RESULTS_REF_UPDATE_EVENT = 'default-grid.results-ref-update';

/**
 * Custom hook to manage lifecycle event listener for results ref updates.
 * Listens to the RESULTS_REF_UPDATE_EVENT and updates the ref when the event is triggered.
 *
 * @returns {Object} - A ref object that gets updated when the event is triggered
 */
export const useResultsRefUpdate = () => {
  const resultsRef = useRef(null);

  useEffect(() => {
    const handleResultsRefUpdate = (event) => {
      if (event?.output.ref) {
        resultsRef.current = event.output.ref;
      }
    };

    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on(RESULTS_REF_UPDATE_EVENT, handleResultsRefUpdate);

    return () => {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.off(RESULTS_REF_UPDATE_EVENT, handleResultsRefUpdate);
    };
  }, []);

  return resultsRef;
};
